




























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";

const Root = namespace("root");
const product = namespace("product");
@Component({ components: {} })
export default class exportProducts extends Vue {
  @Root.Action exportProductExcelKone;
  @product.State exportParams;

  visible: boolean = false;
  isFilter = false;
  notice: any = "";

  @Watch("visible")
  onvisibleChange(val, oldVal) {
    let condition: any = this.exportParams.conditionList;
    if (condition && condition.length > 0) {
      this.isFilter = true;
    } else {
      this.isFilter = false;
    }
  }
  handelCancel() {
    this.visible = false;
  }
  async handleExport() {
    this.notice && this.notice.close();
    await this.exportProductExcelKone({
      condition: {
        ...this.exportParams
      }
    });
    this.visible = false;
    (window as any).handleViewExport = this.handleViewExport.bind(this);
    this.notice = this.$message({
      type: "success",
      duration: 5000,
      showClose: true,
      dangerouslyUseHTMLString: true,
      customClass: "gt-export-dialog-message-wrap",
      message: `<div class="gt-export-dialog-product-success">    
          <p>${this.$t("Product.success_export")}</p>
          <p class="gt-export-dialog-product-view" onclick="handleViewExport()">${this.$t(
            "Product.view_export"
          )}</p></div>`
    });
  }
  handleViewExport() {
    this.notice && this.notice.close();
    this.$router.push({ name: "Export" });
  }
  destroyed() {
    this.notice && this.notice.close();
  }
}
